import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export const getData = async (index, collectionName) => {
    try {
        const docRef = doc(db, collectionName, index);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return null;
        }
    } catch (error) {
        throw error;
    }
};

export const setData = async (index, collectionName, data) => {
    try {
        const docRef = doc(db, collectionName, index);
        await setDoc(docRef, data);
    } catch (error) {
        throw error;
    }
};